import { createContext, useContext } from 'react';

// Staff roles are a strict hierarchy: ADMIN > CURATOR > EMPLOYEE. A role can do everything
// the roles below it can, so permissions are granted by minimum role, never by a role list.
const RANK = { EMPLOYEE: 1, CURATOR: 2, ADMIN: 3 };
const atLeast = (role, min) => (RANK[role] || 0) >= RANK[min];

/**
 * What a staff role may change in the central Brandstore admin. Mirrors SecurityConfig's
 * /api/admin/brandstore/** rules — the server enforces them; this only hides controls that
 * would 403, so a view-only role sees a clean read-only screen instead of failing buttons.
 */
export const brandstoreAccessFor = (role) => ({
  // Companies, campaigns, billing/invoices, reward points, partner API keys.
  canManage: atLeast(role, 'ADMIN'),
  // Per-employee reward balances and history are personal data — admin only.
  canViewRewards: atLeast(role, 'ADMIN'),
  canUpdateOrders: atLeast(role, 'EMPLOYEE'),
  canProcessReturns: atLeast(role, 'EMPLOYEE'),
  // Catalog import into a campaign: same roles as /api/admin/catalog-imports (ADMIN, CURATOR).
  canImportCatalog: atLeast(role, 'CURATOR'),
});

export const BrandstoreAccessContext = createContext(brandstoreAccessFor(null));

export const useBrandstoreAccess = () => useContext(BrandstoreAccessContext);
